export enum BuyingRequisiteAddressTypes {
    CARD = "card",
    PHONE = "phone",
}